export enum HouseType {
  house = 'house',
  sharedResidence = 'shared_residence',
}

export enum ChargingStationPlacement {
  inside = 'inside',
  outsideWall = 'outside_wall',
  outsidePole = 'outside_pole',
}

export enum ChargingStationDistance {
  lessThan5 = 'less_than_5',
  from5to15 = 'from_5_to_15',
  moreThan15 = 'more_than_15',
}

export enum ElectricPhase {
  singlePhase = 'single_phase',
  threePhase = 'three_phase',
  threePhaseNeutral = 'three_phase_neutral',
}
export enum HouseAge {
  lessThan10Years = 'less_than_10_years',
  moreThan10Years = 'more_than_10_years',
}

export enum Status {
  inProgress = 'IN_PROGRESS',
  completed = 'COMPLETED',
  done = 'DONE',
}
